import Breeds from "./breeds"
import pitbull from '../images/pitbull1.png'
import Navbar from "../navbar"



export const Pittbull = () => {
    return (
        <div>
            <Navbar />
            <div className='container'>
                <div className='row  text-left align-items-center justify-content-center'>
                    <div className="col-lg-10">
                        <h1>Pitbull</h1>
                        <img src={pitbull} className='img-fluid w-50' alt="" />
                        <h6>HISTORY:
                        </h6>
                        <p>
                            The American Pit Bull Terrier has been around for over 150 years. Originally designed to be the ultimate gladiator, the American Pit Bull Terrier was bred to be a physically active, agile, and tenacious breed of great power, athleticism, and musculature.
                        </p>

                        <p>  Designed in England, Ireland, and Scotland during the nineteenth century by dog fanciers looking for a dog that exhibits the tenacity and gameness of the terrier combined with the strength of the Bulldog, the American Pit Bull Terrier is personalized with all of the qualities of a great warrior: power, courage, and tenderness with its loved ones.</p>

                        <p>     These qualities make the American Pit Bull Terrier a very versatile breed once sought after as a gladiator, catch dog, hunter, to drive cattle, and loyal family companion. </p>

                       <p> Today the breed has evolved into the ultimate companion and competitor in many performance and conformation events. For over a century the American Pit Bull Terrier has maintained breed type true to its athletic roots and any deviation that may impair its ability to perform its traditional work, or have an effect on the health and welfare of the dog should be considered a fault; and the seriousness of this fault is measure by its degree of effect. Any Characteristics that clearly indicate impurity or crossing of other breeds is not tolerated.</p>

                        <h6 >GENERAL APPEARANCE: </h6>
                        <p>
                            The American Pit Bull Terrier is a powerful and athletic dog of medium size, gracious and agile with a solid build, short and smooth coat, and well-defined musculature without being overdone or appearing bulky, nor fine-boned and rangy. 
                            </p>

                          <p>  The body is slightly longer than it is tall, giving special consideration to bitches that may be a bit longer in body than males.</p>
                             <p>The American Pit Bull Terrier must possess the functional capability to serve as a catch dog that can hold, wrestle, and breathe easily while performing its task, making balance and harmony of all parts fundamental to breed type. </p>

                          <p>   Serious Faults: Any unproportioned or overdone characteristic that may interfere with physical or working ability. Example: too short of leg, excessive bone, massive head or massive body.</p>

                        <h6>CHARACTERISTICS:
                        </h6>
                        <p>
                            The American Pit Bull Terrier is a highly intelligent terrier breed exhibiting confidence, a zest for life, enthusiasm, and an exuberant willingness to please; this making the American Pit Bull Terrier an excellent family companion with a noted love of children. 
                            
                            </p>
                            <p>The breed does exhibit some level of dog aggression; hence making it is imperative that owners carefully socialize and obedience train the dog. The APBT is extremely friendly, even with strangers; therefore, any aggressive behavior toward humans is highly uncharacteristic of the breed and highly undesirable.</p>



                        <p>
                            Disqualifications: Viciousness or extreme shyness.
                        </p>



                    </div>

                </div>
            </div>
        </div>

    )

}